<template>
	<v-container>
		<v-row>
			<v-col cols="6">
				<div class="image-upload-button-wrapper">
					<div class="image-upload-button" :style="buttonCss">
						<span>Choose a file from your computer (2MB maximum)</span>
						<input type="file"  ref="upload" title @change="onFileChange" :accept="accept" />
					</div>
				</div>
			</v-col>
			<v-col cols="6">
				<div class="image-upload-button-wrapper">
					<div v-if="imageUrl" class="preview-image-container">
						<img :src="imageUrl" class="preview-image" />
						<div class="clear-button text-end" :style="{ backgroundImage: `url(${images.cross})` }" @click="clear"></div>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { getUserId } from '@/services/UserService';
import cross from '@/assets/images/cross.svg';
import '@/assets/scss/custom.scss';

export default {
	props: {
		imageUrl: {
			type: String,
			default: '',
		},
		maxFileSize: {
			type: Number,
			default: 2 * 1024 * 1024,
		},
		accept: {
			type: String,
			default: 'image/jpeg,image/png',
		},
		newColor: {
			type: String,
		}
	},
	computed: {
		buttonCss() {
			return { 'background-color': this.newColor };
		}
	},
	data() {
		return {
			images: {
				cross,
			},
			file: null,
		};
	},
	methods: {
		upload() {
			return new Promise((resolve, reject) => {
				if (this.file) {
					const userId = getUserId();
					this.$repo.file
						.upload(this.file, userId, userId)
						.then(resolve)
						.catch(reject);
				} else {
					resolve();
				}
			});
		},
		clear() {
			this.imageUrl = '';
			this.file = null;
			this.$emit('clear');
		},
		onFileChange(ev) {
			const input = ev.target;
			if (input.files && input.files[0]) {
				if (!this.isFileValid(input.files[0])) {
					this.clear();
					return;
				}

				this.file = input.files[0];
				const fileReader = new FileReader();
				fileReader.onload = (ev) => {
					this.imageUrl = ev.target.result;
				};
				fileReader.readAsDataURL(input.files[0]);
			} else {
				this.clear();
			}
		},
		isFileValid(file) {
			if (file.size > this.maxFileSize) {
				this.$emit('error', 'File is bigger than 2MB');
				return false;
			}

			return true;
		},
	},
};
</script>

<style scoped lang="scss">
.image-block{
  text-align: center;
  img {
    width: 100%;
  }
}
.preview-image-container {
	position: relative;
}

.preview-image {
	background-color: #fff;
	max-height: 300px;
	margin: 0 auto;
	display: block;
	margin: 0 auto 15px;
}

.clear-button {
	position: absolute;
	top: 10px;
	right: 10px;
	width: 24px;
	height: 24px;
	background-repeat: no-repeat;
	background-size: contain;
	cursor: pointer;
	z-index: 2;
}

.image-upload-button {
	// background-color: #b9b9b9;
	padding: 10px;
	cursor: pointer;
	transition: 0.3s ease all;
	text-align: center;
	color: #fff;
	font-size: 12px;
	margin: 15px auto;
	position: relative;

	&:hover {
		background-color: #a2a2a2;
	}

	input[type='file'] {
		display: block;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
		cursor: pointer;
		opacity: 0;
	}
}
</style>
